import styled from 'styled-components';
import { Svg } from '../Icons/Svg';
import { Back } from '../Icons';

const Button = styled.button`
    position: relative;
    left: 15%;
    text-transform: uppercase;
    background: transparent;
    font-size: 120%;
    font-family: inherit;
    font-weight: 600;
    letter-spacing: 0.1em;
    border: 2px white solid;
    border-radius: 10px;
    cursor: pointer;
    color: white;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 5px;
    transition: background 0.25s;

    :hover {
        background: rgba(255, 255, 255, 0.4);
    }

    > ${Svg} {
        width: 36px;
        height: 36px;
        fill: white;
    }

    @media (max-width: 1210px) {
        left: 5%;
    }

    @media (max-width: ${(props) => props.theme.mobileLimit}) {
        height: 42px;
        width: 42px;
        font-size: 0;

        > ${Svg} {
            width: 30px;
            height: 30px;
        }
    }
`;

const ButtonText = styled.span`
    @media (max-width: 900px) {
        display: none;
    }
`;


const BackButton = ({ onClick, text }) => {
    return (
        <Button onClick={onClick}>
            <Back/>
            <ButtonText>{ text }</ButtonText>
        </Button>
    );
};

export { BackButton };
